module.exports = __webpack_public_path__ + "img/poster-2.5d58a577.jpg";